<template>
  <div v-clickoutside="closePicker" style="width: 100px; display: inline-block">
    <input class="ant-calendar-picker-input ant-input" v-model="message" readonly @focus="show" @click="clickIcon" @mouseenter="handleInputMouseenter" @mouseleave="handleInputMouseleave"  placeholder="请选择季度" />
    <div v-show="visible" class="pickerCard">
      <div class="pickHeader">
        <span class="pickerIconBtn leftIcon ivu-date-picker-prev-btn-arrow-double" @click="changeYear('last')">
          <LeftOutlined />
        </span>
        <span>
          {{year}}年
        </span>
        <span class="pickerIconBtn rightIcon ivu-date-picker-next-btn-arrow-double" @click="changeYear('next')">
          <RightOutlined />
        </span>
      </div>
      <div class="pickQuarterCard">
        <span v-for="item in dataList" :key="item.value" :class="item.disable ?'disableSpan': 'defaultSpan'" @click="handleClick(item)">
          <em :class="!item.disable && quarter===item.value ? 'selected': 'defaultEm'">{{item.label}}</em>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { LeftOutlined, RightOutlined } from "@ant-design/icons-vue";
import { reactive, toRefs } from "@vue/reactivity";
import { computed, onMounted, watch } from "@vue/runtime-core";
export default {
  name: "quarter-picker",
  props: {
    options: {
      // 不可选日期
      type: Object,
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String],
      default: "",
    },
  },
  components: { LeftOutlined, RightOutlined },
  setup(props, { emit }) {
    const state = reactive({
      visible: false,
      message: null,
      year: null,
      quarter: null,
      currentYear: null,
      currentQuarter: null,
      dataList: [
        { label: "第一季度", value: 1, disable: false },
        { label: "第二季度", value: 2, disable: false },
        { label: "第三季度", value: 3, disable: false },
        { label: "第四季度", value: 4, disable: false },
      ],
      showClose: false,
    });


    const initData = () => {
      if (props.value) {
        const arr = props.value.split("Q");
        state.year = arr[0];
        state.quarter = arr[1];
        state.message = props.value;
      } else {
        state.year = state.currentYear;
        state.quarter = state.currentQuarter;
        state.message = "";
      }
    };
    const handleInputMouseenter = () => {
      state.showClose = state.message && state.clearable;
    };
    const handleInputMouseleave = () => {
      state.showClose = false;
    };
    const clickIcon = () => {
      if (state.showClose) {
        state.quarter = null;
        state.message = null;
        emit("on-change", state.message, state.year, null);
      }
    };
    const changeYear = (type) => {
      if (type === "last") {
        state.year--;
      } else {
        state.year++;
      }
      if (state.year === state.currentYear) {
        state.quarter = state.currentQuarter;
      } else {
        state.quarter = null;
      }
      state.handleData();
    };
    const handleData = () => {
      if (state.options && state.options.disabledDate) {
        state.dataList.forEach((item) => {
          item.disable = state.options.disabledDate(state.year, item.value);
        });
      }
    };
    const handleClick = (item) => {
      if (item.disable) return;
      state.quarter = item.value;
      state.message = state.year + "Q" + item.value;
      emit("on-change", state.message, state.year, item.value);
      closePicker();
    };
    const closePicker = () => {
      state.visible = false;
    };
    const show = () => {
      handleData();
      state.visible = true;
    };
    watch(props, () => {
      if (props.value !== state.message) {
        initData();
      }
    });

    onMounted(() => {
      state.currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      if (currentMonth < 4) {
        state.currentQuarter = 1;
      } else if (currentMonth < 7) {
        state.currentQuarter = 2;
      } else if (currentMonth < 10) {
        state.currentQuarter = 3;
      } else {
        state.currentQuarter = 4;
      }
      initData();
    });
    return {
      ...toRefs(state),
      show,
      handleInputMouseenter,
      handleInputMouseleave,
      clickIcon,
      changeYear,
      closePicker,
      handleClick,
    };
  },
};
</script>

<style scoped lang="less">
.pickerCard {
  width: 200px;
  font-size: 12px;
  z-index: 100;
  background: #fff;
  border-radius: 0.3rem;
  position: absolute;
  margin: 5px 0;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  .pickHeader {
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-bottom: 1px solid #e8eaec;
    .leftIcon {
      float: left;
    }
    .rightIcon {
      float: right;
    }
    .pickerIconBtn {
      display: inline-block;
      width: 20px;
      height: 24px;
      line-height: 26px;
      margin-top: 2px;
      text-align: center;
      cursor: pointer;
      color: #c5c8ce;
      transition: color 0.2s ease-in-out;
    }
  }
  .pickQuarterCard {
    margin: 10px 8px;
    white-space: normal;
    span {
      //width: 60px;
      height: 28px;
      line-height: 28px;
      margin: 10px 12px;
      border-radius: 3px;
      cursor: pointer;
      display: inline-block;
      em {
        padding: 0 10px;
        height: 28px;
        line-height: 28px;
        display: inline-block;
        margin: 0;
        font-style: normal;
        border-radius: 3px;
        text-align: center;
        transition: all 0.2s ease-in-out;
      }
    }
    .disableSpan {
      cursor: not-allowed;
      color: #c5c8ce;
      background: #f7f7f7;
    }
    .defaultSpan:hover .defaultEm {
      background: #e1f0fe;
    }
    .defaultSpan .selected {
      background: #2d8cf0;
      color: #fff;
    }
  }
}
</style>